import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid, Slider, useTheme } from "@mui/material";

interface OfferStyleSliderProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  xs?: number;
  disabled?: boolean;
}

export const OfferStyleSlider = ({
  label,
  value,
  onChange,
  min = 0,
  max = 20,
  xs = 6,
  disabled,
}: OfferStyleSliderProps) => {
  const theme = useTheme();

  const sliderStyles = {
    height: 4,
    "& .MuiSlider-track": {
      border: "none",
      backgroundColor: theme.igBorders.core.hover,
    },
    "& .MuiSlider-rail": {
      backgroundColor: theme.igBorders.core.default,
    },
    "& .MuiSlider-thumb": {
      height: 16,
      width: 16,
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.igBorders.core.default}`,
      boxShadow: theme.igShadows.low,
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: theme.igShadows.high,
      },
    },
    "& .MuiSlider-valueLabel": {
      color: theme.palette.text.primary,
    },
  };

  return (
    <Grid item xs={xs} container direction="column" rowSpacing={2}>
      <Grid item>
        <IgTypography variant="body1">{label}</IgTypography>
      </Grid>
      <Grid item>
        <Slider
          disabled={disabled}
          value={value || 0}
          onChange={(_, newValue) => onChange(newValue as number)}
          min={min}
          max={max}
          valueLabelDisplay="auto"
          sx={sliderStyles}
        />
      </Grid>
    </Grid>
  );
};
